import { ComponentOptions } from 'coveo-search-ui';

export interface IDynamicTextOptions {
	authorDefinedText: string;
}

export class DynamicText {

	constructor(element: HTMLElement, component: any, public options: IDynamicTextOptions) {
		this.options = ComponentOptions.initComponentOptions(element, component, options);
	}

	public generateText(tokens: object) {
		var result = this.options.authorDefinedText.slice(0);
		Object.keys(tokens).forEach((key) => result = result.replace("{" + key + "}", String(tokens[key])));
		return result;
	}
}



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/models/DynamicTextOptions.ts